import * as React from 'react';
import { Fab } from '@mui/material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { IResolveAction } from './interfaces';

export const ResolveAction: React.FC<IResolveAction> = ({
  onClick,
}): JSX.Element => {
  return (
    <Fab color="success" onClick={onClick}>
      <TaskAltIcon />
    </Fab>
  );
};
